import { IconLoader } from '@ui/src';
import ColumnHead from './column-head';
import ColumnRowRoles from '../column-row/column-row-roles';
import { ColumnRolesTypes } from './types';

import cn from './column.module.css';

const ColumnRoles = ({
  roles,
  isLoading,
  roleId,
  emptyTitle,
  popupIsOpen,
}: ColumnRolesTypes): React.JSX.Element => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content =
      roles && roles?.length > 0 ? (
        <div
          className={`${cn.columnContent} ${popupIsOpen ? cn.lessHeight : ''}`}
        >
          {roles?.map((role) => (
            <ColumnRowRoles
              role={role}
              key={role.id}
              isSelectedRow={role.id === roleId}
            />
          ))}
        </div>
      ) : (
        <div className={cn.emptyTitle}>{emptyTitle}</div>
      );
  }
  return (
    <div className={cn.column}>
      <ColumnHead title="Roles" />
      {content}
    </div>
  );
};

export default ColumnRoles;
